import { categories, mainSiteUrl } from '@/mocks/categories';
import { useNavigate } from 'react-router-dom';

export default function Footer() {
  const navigate = useNavigate();

  return (
    <footer className="relative bg-foreground-900 text-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-12">
          <div className="md:col-span-4">
            <button
              onClick={() => navigate('/')}
              className="inline-block text-2xl md:text-3xl font-heading font-bold tracking-tight mb-5 hover:opacity-80 transition-opacity cursor-pointer text-background-50"
            >
              CSSBuy<span className="font-light italic text-foreground-400">.wiki</span>
            </button>
            <p className="text-foreground-400 text-sm leading-relaxed mb-8 max-w-xs">
              O guia mais completo sobre CSSBuy Spreadsheet. Aprenda a comprar da China com organização, segurança e economia.
            </p>
            <div className="flex items-center gap-3">
              {['twitter-x-line', 'instagram-line', 'youtube-line', 'github-line'].map((icon) => (
                <a
                  key={icon}
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="w-9 h-9 rounded-full border border-foreground-600 flex items-center justify-center text-foreground-400 hover:text-background-50 hover:border-background-50 transition-all duration-300 cursor-pointer"
                >
                  <i className={`ri-${icon} text-sm`}></i>
                </a>
              ))}
            </div>
          </div>

          <div className="md:col-span-4">
            <div className="space-y-8">
              <div>
                <p className="text-foreground-400 text-xs font-semibold uppercase tracking-[0.2em] mb-2">Endereço</p>
                <p className="text-background-50/80 text-sm leading-relaxed">
                  Disponível online 24/7<br />
                  Acesse de qualquer lugar
                </p>
              </div>
              <div>
                <p className="text-foreground-400 text-xs font-semibold uppercase tracking-[0.2em] mb-2">Navegação</p>
                <div className="flex flex-wrap gap-x-4 gap-y-1.5">
                  <button onClick={() => navigate('/')} className="text-background-50/60 text-xs hover:text-background-50 transition-colors cursor-pointer">Início</button>
                  <button onClick={() => navigate('/guia-de-compras')} className="text-background-50/60 text-xs hover:text-background-50 transition-colors cursor-pointer">Guia de Compras</button>
                  <button onClick={() => navigate('/artigo/cssbuy-spreadsheet-guia')} className="text-background-50/60 text-xs hover:text-background-50 transition-colors cursor-pointer">Blog</button>
                </div>
              </div>
              <div>
                <p className="text-foreground-400 text-xs font-semibold uppercase tracking-[0.2em] mb-2">Categorias</p>
                <div className="flex flex-wrap gap-x-3 gap-y-1.5">
                  {categories.slice(0, 7).map((cat) => (
                    <a
                      key={cat.seq}
                      href={cat.link}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-background-50/60 text-xs hover:text-background-50 transition-colors cursor-pointer"
                    >
                      {cat.namePt}
                    </a>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="md:col-span-4 flex justify-start md:justify-end">
            <div className="w-40 h-48 md:w-48 md:h-56 rounded-xl overflow-hidden bg-foreground-800">
              <img
                src="https://readdy.ai/api/search-image?query=Minimalist%20fashion%20accessory%20editorial%20product%20photography%20warm%20cognac%20leather%20item%20on%20clean%20warm%20gray%20surface%20soft%20natural%20side%20lighting%20elegant%20sophisticated%20composition%20refined%20aesthetic%20neutral%20warm%20tones%20artful%20presentation%20vertical%20orientation&width=500&height=600&seq=footer-product-v3&orientation=portrait"
                alt="CSSBuy Spreadsheet featured product"
                className="w-full h-full object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-700/50">
        <div className="max-w-[1280px] mx-auto px-4 md:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-500 text-xs">
            &copy; {new Date().getFullYear()} CSSBuy.wiki. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-5">
            <button onClick={() => navigate('/')} className="text-foreground-500 text-xs hover:text-background-50 transition-colors cursor-pointer">Termos</button>
            <button onClick={() => navigate('/')} className="text-foreground-500 text-xs hover:text-background-50 transition-colors cursor-pointer">Privacidade</button>
            <button onClick={() => navigate('/')} className="text-foreground-500 text-xs hover:text-background-50 transition-colors cursor-pointer">Sobre</button>
          </div>
        </div>
      </div>
    </footer>
  );
}